import React from "react";
import { Trans } from "@lingui/macro";
import { ButtonLink } from "../ButtonLink/ButtonLink";

export type typeOrderedProductsTable = {
  variant?: string;
  labelsList: string[];
};

export const LabelList: React.FC<typeOrderedProductsTable> = ({
  labelsList,
}) => {
  const [openList, setOpenList] = React.useState(false);
  const [tempLabelsList, setTempLabelsList] = React.useState(
    labelsList === null
      ? []
      : labelsList.length > 3
        ? labelsList.slice(0, 2)
        : labelsList,
  );

  const onOpenClick = () => {
    if (openList) {
      setTempLabelsList(labelsList.slice(0, 2));
      setOpenList(false);
    } else {
      setTempLabelsList(labelsList);
      setOpenList(true);
    }
  };

  return (
    <div className="divide-y">
      {openList && (
        <ButtonLink
          name="labels"
          type="button"
          onClick={onOpenClick}
          label={<Trans>Collapse</Trans>}
          buttonClassName="px-2 text-center "
        />
      )}
      {labelsList &&
        tempLabelsList.map((mark: string, index: number) => {
          return (
            <p key={mark + index} className="px-2 max-w-sm overflow-hidden">
              {mark}
            </p>
          );
        })}
      {labelsList && labelsList.length > 3 && (
        <ButtonLink
          name="labels"
          type="button"
          onClick={onOpenClick}
          buttonClassName="px-2 text-center"
          label={
            openList ? <Trans>Collapse</Trans> : <Trans>... See all</Trans>
          }
        />
      )}
    </div>
  );
};
